// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__0pvr2","emailContainer":"styles_emailContainer__iRezb","label":"styles_label__OvaX0","title":"styles_title__xaO17","desc":"styles_desc__eouhk"};